<template>
  <div v-if="from.expatriateOrderId">
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title">
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="left flex-between">
                <div
                  class="title-control flex-between"
                  @click="showHandleData = !showHandleData"
                >
                  <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </div>
                <p class="title">
                  {{ $lange == "en" ? "最终报告及费用" : "最终报告及费用" }}
                </p>
                <span></span>
              </div>
            </el-col>
            <el-col :span="12" v-if="isHandleV2">
              <div class="right" style="margin-right:16px">
                <el-button
                  style="width: 150px"
                  type="primary"
                  size="mini"
                  v-if="!showEdit"
                  @click="showEdit = true"
                  >{{ $lange == "en" ? "填写费用" : "填写费用" }}</el-button
                >
                <el-button
                  style="width: 150px"
                  size="mini"
                  v-if="showEdit"
                  @click="showEdit = false"
                  >{{ $lange == "en" ? "取消" : "取消" }}</el-button
                >
                <el-button
                  style="width: 150px"
                  type="primary"
                  size="mini"
                  v-if="showEdit"
                  @click="save"
                  >{{ $lange == "en" ? "保存费用" : "保存费用" }}</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  v-if="!showEdit && from.infoList.length > 0"
                  @click="sendMes"
                  style="width: 150px"
                  >{{ $lange == "en" ? "推送客户" : "推送客户" }}</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
        <el-collapse-transition>
          <div v-if="showHandleData">
            <div class="input_wrap">
              <div class="input_list">
                <span style="min-width: 120px">服务费用（元）:</span>
                <span v-if="!showEdit">{{
                  expatriateFee.serviceFee === ""
                    ? "暂无"
                    : expatriateFee.serviceFee
                }}</span>
                <el-input
                  :min="0"
                  v-if="showEdit"
                  type="number"
                  size="mini"
                  style="width: 100px"
                  v-model="from.serviceFee"
                ></el-input>
              </div>
              <div class="input_list">
                <span style="min-width: 105px">交通费（元）:</span>
                <span v-if="!showEdit">{{
                  expatriateFee.trafficFee === ""
                    ? "暂无"
                    : expatriateFee.trafficFee
                }}</span>
                <el-input
                  :min="0"
                  v-if="showEdit"
                  type="number"
                  size="mini"
                  style="width: 100px"
                  v-model="from.trafficFee"
                ></el-input>
              </div>
              <div class="input_list">
                <span style="min-width: 90px">餐宿（元）:</span>
                <span v-if="!showEdit">{{
                  expatriateFee.accommodationFee === ""
                    ? "暂无"
                    : expatriateFee.accommodationFee
                }}</span>

                <el-input
                  :min="0"
                  v-if="showEdit"
                  type="number"
                  size="mini"
                  style="width: 100px"
                  v-model="from.accommodationFee"
                ></el-input>
              </div>
            </div>
            <div class="file2">
              <div class="file2_title">最终报告：</div>
              <div>
                <div v-if="from.infoList.length == 0 && !showEdit">无</div>

                <div
                  class="file2_list"
                  v-for="(file, index) in from.infoList"
                  :key="index"
                >
                  <el-link :href="file.accessoryUrl" target="_blank">{{
                    file.fileName ? file.fileName : file.accessoryUrl
                  }}</el-link>
                  <span
                    v-if="showEdit"
                    @click="deleteAccessoryInfoList(index)"
                    style="margin-left: 10px; color: red"
                    >删除</span
                  >
                </div>
              </div>
              <div style="margin-left: 10px">
                <el-button
                  v-if="showEdit && from.infoList.length == 0"
                  size="mini"
                  style="width: 100%"
                  @click="openUploaderDialog = true"
                  >上传最终报告</el-button
                >
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="openUploaderDialog"
      width="30%"
      append-to-body
    >
      <template v-if="openUploaderDialog">
        <div class="uploader">
          <cc-uploader
            :config="uploaderConf2"
            uploadType="dottedMultiple"
            @upload-success="uploadTrue"
            :isMultiple="false"
          />
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    expatriateData: Object,
    isHandleV2: Boolean,
  },
  data() {
    return {
      showHandleData: true,
      showEdit: false,
      from: {
        serviceFee: "",
        trafficFee: "",
        accommodationFee: "",
      },
      expatriateFee: {},
      openUploaderDialog: false,
      uploaderConf2: this.$uploadUtils.config, //文件上传需要
    };
  },
  methods: {
    save() {
      if (this.from.accommodationFee && this.from.accommodationFee < 0) {
        this.$message.error("金额不可为负数");
        return false;
      }
      if (this.from.serviceFee && this.from.serviceFee < 0) {
        this.$message.error("金额不可为负数");
        return false;
      }
      if (this.from.trafficFee && this.from.trafficFee < 0) {
        this.$message.error("金额不可为负数");
        return false;
      }
      this.$confirm("你当前的操作设置相关费用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let from = {
            // expatriateOrderId: this.expatriateData.id,
            ...this.from,
          };
          if (from.accommodationFee > 0) {
            from.accommodationFee = from.accommodationFee * 100;
          }
          if (from.serviceFee > 0) {
            from.serviceFee = from.serviceFee * 100;
          }
          if (from.trafficFee > 0) {
            from.trafficFee = from.trafficFee * 100;
          }

          console.log(from);
          this.ccRequest
            .do("admin/fsb/expatriate/addExpatriateFee ", from, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.$emit("updateOrder", true);

              this.getData();
              this.showEdit = false;
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    getData() {
      this.ccRequest
        .do(
          "admin/fsb/expatriate/getExpatriateFee",
          { expatriateOrderId: this.expatriateData.id },
          "GET"
        )
        .then((res) => {
          this.from = { ...res };
          this.expatriateFee = { ...res };
          if (this.from.accommodationFee !== "") {
            this.from.accommodationFee = this.from.accommodationFee / 100;
            this.expatriateFee.accommodationFee = (
              this.expatriateFee.accommodationFee / 100
            ).toFixed(2);
          }

          if (this.from.serviceFee !== "") {
            this.from.serviceFee = this.from.serviceFee / 100;
            this.expatriateFee.serviceFee = (
              this.expatriateFee.serviceFee / 100
            ).toFixed(2);
          }
          if (this.from.trafficFee !== "") {
            this.from.trafficFee = this.from.trafficFee / 100;

            this.expatriateFee.trafficFee = (
              this.expatriateFee.trafficFee / 100
            ).toFixed(2);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });
    },
    uploadTrue(e) {
      console.log(e, "uploadTrue");
      this.from.infoList = [e];
      this.openUploaderDialog = false;
    },
    deleteAccessoryInfoList(index) {
      this.from.infoList.splice(index, 1);
    },
    sendMes() {
      this.$confirm("你当前的操作会给客户推送通知", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let pData = {
            expatriateOrderId: this.expatriateData.id,
          };
          this.ccRequest
            .do("admin/fsb/expatriate/pushFee", pData, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.$emit("updateOrder", true);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style scoped lang="scss">
.order-solution {
  background: #ffffff;
  margin-top: 5px;
  border-top: 10px solid #f3f3f4;

  .os-list {
    padding: 20px;
    border-bottom: 1px dotted #ccc;
    // border-top: 5px solid #f3f3f4;

    .os-title {
      .left {
        justify-content: flex-start;

        > * {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;
          & ~ .title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }
  }
}
.right {
  display: flex;
  justify-content: flex-end;
}
.input_wrap {
  display: flex;
  margin-top: 20px;
}
.input_list {
  display: flex;
  align-items: center;
  width: 300px;
  span {
    font-weight: bold;
  }
}

.file2 {
  margin-top: 20px;
  display: flex;
  width: 100%;
  .file2_title {
    min-width: 45px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
  .file2_list {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
}
</style>